//
//
//
//
//
//
//
//
//
//
//
//

import MattingControls from "./MattingControls";
import MattingLoading from "./MattingLoading";
import MattingCanvas from "./MattingCanvas";
import MattingAdvanced from "./MattingAdvanced";
const { computed } = window.MattingEngineModule;
export default {
  name: "MattingMain",
  components: {
    MattingControls,
    MattingLoading,
    MattingCanvas,
    MattingAdvanced,
  },
  computed: {
    ...computed,
    loadingStatus() {
      const statusMap = {
        idle: "",
        active: "success",
        fail: "error",
        loading: "loading",
        changeMatting: "loading",
      };
      return statusMap[this.mattingFsmStatus];
    },
  },
  watch: {
    loadingStatus(val) {
      if (val === "error" || val === "success") {
        this.$root.showModalApp = false;
        window.clearInterval(window.bartimer90);
      }
    },
  },
};
